<div class="user-panel">
    @if (menuMode === 'context') {
        <dx-drop-down-button
            stylingMode="text"
            dropDownContentTemplate="dropDownTemplate"
            [icon]="user?.avatarUrl ?? 'user'"
            [showArrowIcon]="true"
            [elementAttr]="{
                class: 'user-button'
            }"
            [dropDownOptions]="{
                width: 'auto'
            }"
            (onContentReady)="handleDropDownButtonContentReady($event)"
        >
            <div *dxTemplate="let data of 'dropDownTemplate'">
                <user-menu-section
                    [menuItems]="menuItems"
                    [showAvatar]="false"
                    [user]="user"
                ></user-menu-section>
            </div>
        </dx-drop-down-button>
    }
    @if (menuMode === 'list') {
        <user-menu-section
            [menuItems]="menuItems"
            [showAvatar]="true"
            [user]="user"
        ></user-menu-section>
    }
</div>
